// extracted by mini-css-extract-plugin
export default {"fs":"_393cb295fb aa565515e3"};